module.exports = __webpack_public_path__ + "img/t3-c3.f4e306e6.png";